import React, { Fragment, useContext } from "react";
import { AppContext } from "../../../components/AppProvider";
import { IC } from "../../../resources/Assets";
import { openLayerFn } from "../../Layout";

export default (props) => {
  const {
    m,
    settingSeqNo,
    openMemoPopup,
    setModifyDisplay,
    setSeqNo,
    setModifyTarget,
    setTargetData,
    i,
  } = props;
  const { phonecfg } = useContext(AppContext);

  return (
    <div className="time-schedule-list" style={{ padding: "0px" }}>
      <Fragment>
        <div style={{ padding: "0px" }}>
          <div
            className={m.column2 == "HIGH" ? "infobox gloom" : "infobox smile"}
            style={{ padding: "12px", border: "1px solid #d0d0d0" }}
          >
            <div className="data01">
              <label className="check-box" style={{ display: "flex" }}>
                <input
                  type="checkbox"
                  name="checkSeqNo"
                  value={m.seqNo}
                  onClick={settingSeqNo}
                />
                <i style={{ paddingRight: "8px" }} />
                <span>
                  {m.date1 + "(" + m.date2 + ") " + m.date3 + m.date4}
                </span>
                <p
                  style={{
                    padding: "0px 12px",
                    marginLeft: "10px",
                    border: "1px solid #009B47",
                    borderRadius: "10px",
                    color: "#fff",
                    backgroundColor: "#009B47",
                  }}
                >
                  {m.column3}
                </p>
              </label>
            </div>

            <div style={{ display: "flex", position: "relative" }}>
              <div style={{ paddingLeft: "30px", paddingTop: "8px" }}>
                {m.column1} <em className="mn">{m.column4}</em>
              </div>

              <div
                style={{ paddingTop: "8px", position: "absolute", right: "0" }}
              >
                <a
                  onClick={() => {
                    setModifyDisplay(true);
                    setSeqNo(m.seqNo);
                    setModifyTarget("BS");
                    setTargetData(m);
                    // testFunction();
                    document.getElementsByTagName('body')[0].classList.add('scrollLock');
                  }}
                >
                  <img src={IC.etc.IC_EDIT} />
                </a>
                <a
                  style={{ marginLeft: "20px" }}
                  onClick={() => {
                    openMemoPopup(m.seqNo, m.memo, props.setModifyTarget);
                    setModifyTarget("BS");
                  }}
                >
                  <img src={IC.etc.IC_NOTE} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    </div>
  );
};

export const IslnHistList = (props) => {
  const {
    m,
    settingSeqNo,
    openMemoPopup,
    setModifyDisplay,
    setSeqNo,
    setModifyTarget,
    setTargetData,
    i,
  } = props;

  return (
    <div className="time-schedule-list" style={{ padding: "0px" }}>
      <Fragment>
        <div style={{ padding: "0px" }}>
          <div
            className={m.column2 == "HIGH" ? "infobox gloom" : "infobox smile"}
            style={{
              padding: "12px",
              border: "1px solid #d0d0d0",
              backgroundColor: "#BEDDD7",
            }}
          >
            <div className="data01">
              <label className="check-box" style={{ display: "flex" }}>
                <input
                  type="checkbox"
                  name="checkInslSeqNo"
                  value={m.seqNo}
                  onClick={settingSeqNo}
                />
                <i style={{ paddingRight: "8px" }} />
                <span>
                  {m.date1 + "(" + m.date2 + ") " + m.date3 + m.date4}
                </span>
                <p
                  style={{
                    padding: "0px 12px",
                    marginLeft: "10px",
                    border: "1px solid #009B47",
                    borderRadius: "10px",
                    color: "#fff",
                    backgroundColor: "#009B47",
                  }}
                >
                  {m.column3}
                </p>
              </label>
            </div>

            <div style={{ display: "flex", position: "relative" }}>
              <div style={{ paddingLeft: "30px", paddingTop: "8px" }}>
                <img src={IC.etc.IC_SYRINGE} />
                {m.column1} IU
              </div>

              <div
                style={{
                  paddingTop: "15px",
                  position: "absolute",
                  right: "0",
                }}
              >
                {/* <a
                                  onClick={() => {
                                      setModifyDisplay(true);
                                      setSeqNo(m.seqNo);
                                      setModifyTarget("INSLN");
                                      setTargetData(m);
                                  }}
                              >
                                  <img src={IC.etc.IC_EDIT} />
                              </a> */}
                <a
                  style={{ marginLeft: "20px" }}
                  onClick={() => {
                    openMemoPopup(m.seqNo, m.memo);
                    setModifyTarget("INSLN");
                  }}
                >
                  <img src={IC.etc.IC_NOTE} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    </div>
  );
};
